import React, { useState, useEffect, useCallback } from "react";
import { useExamStatus } from "../ExamStatusContext";
import { useScoreTable } from "../ScoreContext";
import withResetOnNavigation from '../withResetOnNavigation';
import TestContainer from "../TestContainer";
import ZoomControls from "../ZoomControls";
import "../../../css/test5.css";
import answer from "../QA/Test5_q_a/answer";
import kensa5_example from "../QA/Test5_q_a/kensa5_example.jpg";

const Test5 = ({ onNext }) => {
  const { examStatus } = useExamStatus();
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [inputValues, setInputValues] = useState({});
  const [isTest5Started, setIsTest5Started] = useState(false);
  const [notification, setNotification] = useState("");
  const [isTimeUp, setIsTimeUp] = useState(false);
  const score5 = React.useRef(0);
  const scoreTable = useScoreTable();

  const testDuration = 90;
  const totalQuestions = 24;

  useEffect(() => {
    const test5Status = localStorage.getItem("test5Status");
    if (examStatus === "検査中" && test5Status === "started") {
      localStorage.setItem("test5Status", "notStarted");
    }
  }, [examStatus]);

  const gradeTest = useCallback(() => {
    let calculatedScore = 0;

    for (let i = 0; i < totalQuestions; i++) {
      const userAnswer = inputValues[i + 1];
      const correctAnswer = answer[i + 1];
      if (userAnswer === correctAnswer) {
        calculatedScore += 1;
      }
    }

    score5.current = calculatedScore;
    localStorage.setItem("score5", calculatedScore);

    const normalizedScore = scoreTable.scoreTable6[String(calculatedScore)] ?? 0;
    const currentPScore = parseInt(localStorage.getItem("P_score"), 10) || 0;
    localStorage.setItem("P_score", currentPScore + normalizedScore);

    setNotification("検査を終了します！");
    setIsTimeUp(true);

    if (onNext) onNext(); // ← ここで次へ進む
  }, [inputValues, scoreTable, onNext]);

  const handleStartTest = () => {
    setIsTest5Started(true);
    localStorage.setItem("test5Status", "started");
  };

  const handleInputChange = (index, value) => {
    setInputValues((prev) => ({
      ...prev,
      [index]: value,
    }));
    if (value !== "-" && index === currentQuestionIndex + 1) {
      setCurrentQuestionIndex(index);
    }
  };

  const getImagePath = (index) =>
    require(`../QA/Test5_q_a/kensa5_${index + 1}.jpg`);

  const renderedQuestions = Array.from({ length: totalQuestions })
    .slice(0, currentQuestionIndex + 1)
    .map((_, index) => (
      <div key={index} className="test5-question">
        <p>問題 {index + 1}</p>
        <img
          src={getImagePath(index)}
          alt={`問題${index + 1}`}
          className="test5-image"
        />
        <select
          value={inputValues[index + 1] || "-"}
          onChange={(e) => handleInputChange(index + 1, e.target.value)}
        >
          <option value="-">-</option>
          <option value="A">A</option>
          <option value="B">B</option>
          <option value="C">C</option>
          <option value="D">D</option>
        </select>
      </div>
    ));

  if (!isTest5Started) {
    return (
      <div className="test5-container">
        <h1>検査3 - やり方の説明</h1>
        <p>
          左の図形とまったく同じぬり方の図形が、右の4つの図形の内に1つあります。それを答えて下さい。
        </p>
        <h2>例題</h2>
        <div className="example-container">
          <img
            src={kensa5_example}
            alt="例題5"
            className="test5-image-example"
          />
        </div>
        <button className="start-button" onClick={handleStartTest}>
          検査に進む
        </button>
      </div>
    );
  }

  return (
    <ZoomControls>
      <TestContainer
        title="検査3"
        isTimeUp={isTimeUp}
        notification={notification}
        renderedQuestions={renderedQuestions}
        manageTimer={true}
        gradeTest={gradeTest}
        testDuration={testDuration}
      />
    </ZoomControls>
  );
};

export default withResetOnNavigation(Test5);
